(() => {
  if (window.__PRICE_CARD_BOUND__) return;
  window.__PRICE_CARD_BOUND__ = true;

  const pCache = new Map();

  function formatMoney(cents, withCode){
    const valor = (Number(cents) || 0) / 100;
    const numeroBR = new Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(valor);

    return withCode ? `R$ ${numeroBR} BRL` : `R$ ${numeroBR}`;
  }

  async function getProduct(handle){
    if (!pCache.has(handle)) {
      const r = await fetch(`/products/${handle}.js`);
      pCache.set(handle, await r.json());
    }
    return pCache.get(handle);
  }

  function installmentsFor(cents){
    const min = 10000; 
    const max = 10;  

    let times = 1;
    let per = cents;

    for (let i = 2; i <= max; i++){
      const p = Math.ceil(cents / i);
      if (p < min) break;

      times = i;
      per = p;
    }

    return { times, per };
  }

  function getCardParts(card){
    const priceRoot = card.querySelector('.product-price .price');
    return {
      priceRoot,
      currentEl: priceRoot?.querySelector('.price__current .js-value') || null,
      wasWrap:   priceRoot?.querySelector('.price__was') || null,
      wasEl:     priceRoot?.querySelector('.price__was .js-value') || null,
      instWrap:  priceRoot?.querySelector('[data-installments-wrap]') || null,
      soldLabel: priceRoot?.querySelector('[data-variant-soldout]') || null,
      withCode:  (priceRoot?.dataset.showCurrencyCode === 'true')
    };
  }

  function updateDorelInfo(card, variant){
    const dorelWrap = card.querySelector('.product-price--dorel');
    if (!dorelWrap) return;

    const pixPct  = parseFloat(dorelWrap.dataset.pixPct)  || 0;
    const instMin = parseFloat(dorelWrap.dataset.instMin)  || 0;
    const instMax = parseInt(dorelWrap.dataset.instMax, 10) || 1;

    const priceReais = (variant ? variant.price : 0) / 100;

    dorelWrap.dataset.priceCents     = String(variant ? variant.price : 0);
    dorelWrap.dataset.compareAtCents = String(variant ? (variant.compare_at_price || 0) : 0);
    dorelWrap.dataset.variantId      = String(variant ? variant.id : '');

    const instEl = dorelWrap.querySelector('.dorel-installments');
    const pixEl  = dorelWrap.querySelector('.dorel-pix');

    if (!variant || !variant.available){
      if (instEl) instEl.textContent = '';
      if (pixEl)  pixEl.textContent  = '';
      return;
    }

    let instCount = 1;
    if (instMin > 0){
      instCount = Math.floor(priceReais / instMin);
      if (instCount > instMax) instCount = instMax;
      if (instCount < 1) instCount = 1;
    }

    if (instEl){
      if (instCount > 1){
        const instValue = priceReais / instCount;
        instEl.textContent = `em até ${instCount}x de ${formatMoney(Math.round(instValue * 100), false)}`;
      } else {
        instEl.textContent = '';
      }
    }

    if (pixEl){
      if (pixPct > 0){
        const pixPrice = priceReais - (priceReais * pixPct / 100);
        pixEl.textContent = `ou ${formatMoney(Math.round(pixPrice * 100), false)} no PIX`;
      } else {
        pixEl.textContent = '';
      }
    }
  }

  function setSoldOutUI(parts, card){
    if (!parts.priceRoot || !parts.currentEl) return;
    parts.priceRoot.dataset.empty = 'true';
    parts.priceRoot.classList.add('price--sold-out');
    parts.priceRoot.classList.remove('price--on-sale');
    parts.currentEl.textContent = '';
    if (parts.wasEl) parts.wasEl.textContent = '';
    if (parts.instWrap) parts.instWrap.innerHTML = '';
    if (parts.soldLabel) parts.soldLabel.hidden = false;
    if (card) updateDorelInfo(card, null);
    if (parts.wasWrap){
      parts.wasWrap.hidden = true;
      parts.wasWrap.setAttribute('hidden', 'hidden');
    }
  }

  function setAvailableUI(parts, variant, card){
    if (!parts.priceRoot || !parts.currentEl) return;
    parts.priceRoot.dataset.empty = 'false';
    parts.priceRoot.classList.remove('price--sold-out');
    parts.priceRoot.classList.toggle('price--on-sale', variant.compare_at_price > variant.price);

    parts.currentEl.textContent = formatMoney(variant.price, parts.withCode);
    if (parts.wasWrap && parts.wasEl){
      if (variant.compare_at_price > variant.price){
        parts.wasWrap.hidden = false;
        parts.wasWrap.removeAttribute('hidden');
        parts.wasEl.textContent = formatMoney(variant.compare_at_price, parts.withCode);
      } else {
        parts.wasWrap.hidden = true;
        parts.wasWrap.setAttribute('hidden', 'hidden');
        parts.wasEl.textContent = '';
      }
    }
    if (parts.soldLabel) parts.soldLabel.hidden = true;

    if (parts.instWrap){
      const inst = installmentsFor(variant.price);
      if (inst.times > 1){
        parts.instWrap.dataset.installments = String(inst.times);
        parts.instWrap.innerHTML = `
          <small class="price__mult">Até ${inst.times}x de</small>
          <small class="price__value">${formatMoney(inst.per, parts.withCode)}</small>
        `;
      } else {
        parts.instWrap.innerHTML = '';
      }
    }
    if (card) updateDorelInfo(card, variant);
  }

  async function updateCardPrice(card, variantId){
    const handle = card?.dataset?.productHandle;
    if (!handle || !variantId) return;

    const parts = getCardParts(card);
    const p = await getProduct(handle);
    const v = p?.variants?.find(x => String(x.id) === String(variantId));
    if (!v){ setSoldOutUI(parts, card); return; }

    if (!v.available) setSoldOutUI(parts, card);
    else setAvailableUI(parts, v, card);
  }

  const seenHandles = new Set();
  const io = ('IntersectionObserver' in window)
    ? new IntersectionObserver((entries)=>{
        entries.forEach(async (e) => {
          if (!e.isIntersecting) return;
          const card = e.target.closest('product-block');
          const handle = card?.dataset?.productHandle;
          if (handle && !seenHandles.has(handle)){
            seenHandles.add(handle);
            getProduct(handle).catch(()=>{});
          }
          io.unobserve(e.target);
        });
      }, {rootMargin:'200px'})
    : null;

  if (io){
    document.querySelectorAll('.product-price .price').forEach(el => io.observe(el));
  }

  document.addEventListener('click', (ev) => {
    const item = ev.target.closest('.product-block-options__item');
    if (!item) return;
    const card = item.closest('product-block');
    const variantId = item.dataset.variantId;
    if (!card || !variantId) return;
    updateCardPrice(card, variantId);
  });
})();
(function () {
  /**
   * Atualiza a badge "Novo" dentro de um <product-block>
   * com base no status da variante e se tem estoque.
   *
   * @param {Element} productBlock - elemento <product-block>
   * @param {string} variantStatus - valor de data-variant-sku-status (ex: "Novo", "Em linha")
   * @param {boolean} variantAvailable - true se tiver estoque
   */
  function updateCardNewBadge(productBlock, variantStatus, variantAvailable) {
    if (!productBlock) return;

    var containers = productBlock.querySelectorAll('.product-label-container');
    if (!containers.length) return;

    var showNovo =
      !!variantStatus &&
      variantStatus.toLowerCase() === 'novo' &&
      !!variantAvailable;

    containers.forEach(function (container) {
      var badge = container.querySelector('.product-label--new-in');
      if (!badge) return;

      if (showNovo) {
        // REMOVE o hidden, senão o CSS continua com display:none !important
        badge.hidden = false;
        badge.removeAttribute('hidden');

        // Deixa visível (caso tenha inline style antigo)
        badge.style.display = '';

        var inner = badge.querySelector('span') || badge;
        inner.textContent = 'Novo';
      } else {
        // Esconde de forma consistente
        badge.hidden = true;
        badge.setAttribute('hidden', 'hidden');
        badge.style.display = 'none';
      }
    });
  }

  // Delegação de clique nos swatches
  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('.product-block-options__item[data-variant-id]');
    if (!swatch) return;

    var productBlock = swatch.closest('product-block');
    if (!productBlock) return;

    var status = (swatch.getAttribute('data-variant-sku-status') || '').trim();

    // usa a classe de indisponível do tema
    var isUnavailable = swatch.classList.contains('product-block-options__item--unavailable');
    var isAvailable = !isUnavailable;

    updateCardNewBadge(productBlock, status, isAvailable);
  });
})();
